import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import { Roles } from 'clickNgo/configs/roles'

import { sortByComment } from './sortByComment'

interface IHandleUsContactFlagsAccessConditionsParams {
  roles: string[]
  email: string
  profilingCodeList: IProfilingCode[]
}

export const handleContactFlagsAccessCondition = ({
  roles,
  email,
  profilingCodeList,
}: IHandleUsContactFlagsAccessConditionsParams) => {
  if (roles.includes(Roles.SUPER_ADMIN_ROLE)) {
    return profilingCodeList
  }

  const filteredCodeList = profilingCodeList.map((code) => {
    // If no roles or users are defined, this code is accessible to everyone
    if ((!code.roles || code.roles.length === 0) && (!code.users || code.users.length === 0)) {
      return code
    }

    // Check if the user has the required role or is listed as a user for this code
    const hasRequiredRole = code.roles.some((role) => roles.includes(role))
    const isRequiredUser = code.users.includes(email)

    // If the user has the required role or is listed as a user, return the code as is
    if (hasRequiredRole || isRequiredUser) {
      return code
    }

    // If the user does not have access, return the code with a comment
    return {
      ...code,
      comment: 'No access granted',
    }
  })

  return sortByComment(filteredCodeList)
}
